import type { CSSProperties, ReactNode } from 'react'

export interface SectionTitleProps {
  overline?: string
  title: ReactNode
  /** Text alignment. Default: 'left'. */
  align?: 'left' | 'center'
  style?: CSSProperties
}

/** Section-level overline chip + h2. For page-level titles use PageHeader instead. */
export function SectionTitle({
  overline,
  title,
  align = 'left',
  style,
}: SectionTitleProps) {
  return (
    <div style={{ textAlign: align, ...style }}>
      {overline && (
        <div className="oumma-overline" style={{ marginBottom: 12 }}>
          {overline}
        </div>
      )}
      <h2 style={{ fontSize: 'var(--text-h2)', margin: 0 }}>{title}</h2>
    </div>
  )
}
